import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type WithId } from "@client/types";
import { setShowingDetailId } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  item: null,
  id: "",

  isVisible: false
};

const makeMapStateToProps = () => {
  return (state: AppState, props: WithId): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.showingVoucherId) return INVISIBLE_PROPS;

    const item = localState.vouchers.find((x) => x.voucherCodeId === localState.showingVoucherId)!;

    return {
      id: props.id,
      item,

      isVisible: true
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingDetailId({ ...getEntityRef(props), itemId: null }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
